// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__A5s99"};